import { Box, Container, Image, Spacer, Stack } from "@chakra-ui/react";
import useSite from "../../hooks/use-site";
import parse from "html-react-parser";
import options from "../../support/parse-settings";
import ShareLinks from "./components/ShareLinks";

const SinglePost = () => {
  const {
    post: { content, featuredImage },
  } = useSite();
  return (
    <Box
      mt={{ base: 0, lg: -20 }}
      position="relative"
      zIndex="5"
      color="#4a5568"
    >
      {featuredImage?.node?.sourceUrl && (
        <Image
          src={featuredImage.node.sourceUrl}
          alt={featuredImage.node.altText}
          mx="auto"
          display="block"
        />
      )}
      <Container my={8} maxW="980px">
        <Stack direction={{ base: "column", md: "row" }} gap={12}>
          <Spacer />
          <Box maxW="800px">{content && parse(content, options)}</Box>
          <Box position="relative">
            <ShareLinks />
          </Box>
        </Stack>
      </Container>
    </Box>
  );
};

export default SinglePost;
